/**
 * Doménová pravidla klínu (Blok D) — stavový řetězec Změny a hlídače.
 * Zdroj pravdy: podklady/10-wedge-navrh.md §3, .claude/knowhow/workflow-viceprace.md.
 */
/**
 * Povolené přechody stavů Změny (10 §3): nová → kvalifikována → oceněna →
 * schválena → v dodatku → fakturovatelná; větve zamítnuta / sporná (claim).
 * NENÍ lineární happy path — sporná se dá vrátit do procesu, zamítnutá znovu
 * otevřít. TVRDÁ BRÁNA (invariant 5): `fakturovatelna` NIKDY ručním přechodem —
 * jen podpisem dodatku (mapa ji připouští pouze z `v_dodatku`, endpoint ruční
 * nastavení odmítá). Vše ostatní je eskalace/příznak, ne zámek.
 */
export const ZMENA_PRECHODY = {
    nova: ['kvalifikovana', 'zamitnuta'],
    kvalifikovana: ['ocenena', 'zamitnuta', 'sporna'],
    ocenena: ['schvalena', 'zamitnuta', 'sporna'],
    schvalena: ['v_dodatku', 'sporna'],
    v_dodatku: ['fakturovatelna', 'sporna'],
    fakturovatelna: [],
    zamitnuta: ['kvalifikovana'],
    sporna: ['ocenena', 'schvalena', 'zamitnuta'],
};
/** Je přechod stavu Změny povolený? (validuje API u každé změny stavu) */
export function jePrechodZmenyPovoleny(od, cil) {
    return ZMENA_PRECHODY[od].includes(cil);
}
/**
 * Výchozí práh hlídače „nález bez Změny" / „neúplná změna" v PRACOVNÍCH dnech
 * (wireframe 13 §2: žlutá ≥5, červená ≥2×práh). Konfigurace per firma:
 * Firma.nastaveni.hlidace.nalezBezZmenyDny.
 */
export const HLIDAC_NALEZ_BEZ_ZMENY_DNY = 5;
/**
 * Počet PRACOVNÍCH dnů (po–pá), které uplynuly od `od` do `ted` (svátky POC
 * neřeší). Vrací 0 pro budoucí data; počítá celé započaté dny.
 */
export function pracovnichDniOd(od, ted = new Date()) {
    const denMs = 24 * 60 * 60 * 1000;
    const zacatek = Date.UTC(od.getUTCFullYear(), od.getUTCMonth(), od.getUTCDate());
    const konec = Date.UTC(ted.getUTCFullYear(), ted.getUTCMonth(), ted.getUTCDate());
    if (konec <= zacatek)
        return 0;
    let dni = 0;
    for (let t = zacatek + denMs; t <= konec; t += denMs) {
        const denVTydnu = new Date(t).getUTCDay();
        if (denVTydnu !== 0 && denVTydnu !== 6)
            dni += 1;
    }
    return dni;
}
//# sourceMappingURL=zmeny.js.map